<template>
    <div class="w-full my-5 tablet-sm:my-8">
        <div class="border tablet-sm:border-double border-accent border tablet-sm:border-4
                    rounded-sm overflow-hidden
                    p-2 tablet-sm:p-4
                   "
        >
            <slot></slot>
        </div>
    </div>
</template>
